import { graphql } from '@/generated/gql';

export const SOURCING_CASE_CONTACT_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation SourcingCaseContactUpdate($id: UUID!, $data: TsrctSourcingCaseContactInput!) {
    tesseract {
      sourcingCase(id: $id) {
        updateContactDetails(data: $data) {
          id
          supplier {
            id
            name
            supplierId
            contact {
              id
              internalId
              firstName
              lastName
              email
              language
            }
          }
        }
      }
    }
  }
`);
